export const PRODUCT_LINES_MAP = {
  'custom-canine-covers': 'Canine Covers Econo Plus Rear Seat Protector',
  'custom-padded-canine-covers': 'Canine Covers Custom Rear Seat Protector'
};

export const PRODUCTS_TYPES_MAP = {
  CAR_COVERS: 'CAR_COVERS',
  SUNSHADES: 'SUNSHADES',
  DASHMATS: 'DASH_MATS',
  CANINE_COVERS: 'CANINE_COVERS'
};

export const PRODUCTS_MAP = {
  weatherguard: {
    handle: 'weatherguard',
    imageHandle: 'weatherguard',
  },
  ultraguard: {
    handle: 'ultraguard',
    imageHandle: 'ultraguard',
  },
  stormguard: {
    handle: 'stormguard',
    imageHandle: 'stormguard',
  },
  "cotton-flannelguard": {
    handle: 'cotton-flannelguard',
    imageHandle: 'flannelguard',
  },
  "flannelguard-supreme": {
    handle: 'flannelguard-supreme',
    imageHandle: 'flannelguard-supreme',
  },
  "bhma-custom-fit-dash-cover": {
    handle: 'bhma-custom-fit-dash-cover',
    imageHandle: 'bhma-custom-fit-dash-cover',
  },
  "bhma-custom-sunshade": {
    handle: 'bhma-custom-sunshade',
    imageHandle: 'bhma-custom-sunshade',
  },
  "custom-padded-canine-covers": {
    handle: 'custom-padded-canine-covers',
    imageHandle: 'custom-padded-canine-covers',
  },
  "custom-canine-covers": {
    handle: 'custom-canine-covers',
    imageHandle: 'custom-canine-covers',
  },
  "custom-canine-back-seat-bed": {
    handle: 'custom-canine-back-seat-bed',
    imageHandle: 'custom-canine-back-seat-bed',
  },
  "quilted-leather-floor-mats": {
    handle: 'quilted-leather-floor-mats',
    imageHandle: 'quilted-leather-floor-mats',
  },
  "carbon-fiber-floor-mats": {
    handle: 'carbon-fiber-floor-mats',
    imageHandle: 'carbon-fiber-floor-mats',
  },
  "sheepskin-floor-mats": {
    handle: 'sheepskin-floor-mats',
    imageHandle: 'sheepskin-floor-mats',
  }
}

// product tags

export const TAG_OUT_OF_STOCK = 'out of stock';
